module.exports = __webpack_public_path__ + "img/audit.057a600e.png";